import styled from 'styled-components'

export const CardRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 96px;
  padding: 16px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 16px;
  background: ${p => p.theme.palette.colors.surfaceSoft};
  box-shadow: 0 14px 30px ${p => p.theme.palette.colors.shadowStrong};
`;

export const CardIcon = styled.div.attrs({})`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.$variant === 'success'
    ? 'rgba(0, 201, 80, 0.16)'
    : p.theme.palette.colors.badgeMuted};
`;

export const CardValue = styled.div.attrs({})`
  font-family: Gilroy;
  margin-top: 2px;
  font-size: 22px;
  line-height: 1;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const CardLabel = styled.div.attrs({})`
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.subdued};
`;
